import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoPasajePage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoPasajePage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoPasaje(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoPasaje', name: 'TipoPasaje', title: 'Tipo Pasaje' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            tipopasaje: {},
            
        };
    },
    methods: {

        newTipoPasaje() {
            this.tipopasaje = {};
            this.$refs['frm-tipopasaje'].show();
        },
        showTipoPasaje(id) {
            this.isLoading=true;
            this.ss.showTipoPasaje(id).then(
                (result) => {
                    let response = result.data;
                    this.tipopasaje = response.data;
                    this.$refs['view-tipopasaje'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoPasaje() {
            this.$refs['frm-tipopasaje'].show();
            this.$refs['view-tipopasaje'].hide();
        },
        cancelTipoPasaje() {
            if (this.tipopasaje.id) {
                this.$refs['view-tipopasaje'].show();
            }
            this.$refs['frm-tipopasaje'].hide();
        },
        saveTipoPasaje() {
            this.ss.storeTipoPasaje(this.tipopasaje).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipopasaje'].hide();
                    this.$refs['datatable-tipopasaje'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoPasaje() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoPasaje(this.tipopasaje)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipopasaje'].hide();
                                this.$refs['datatable-tipopasaje'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        draw() {
            window.$('.btn-datatable-TipoPasaje').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoPasaje(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
